<template>
    <MenuDropDown
        :items="currencyItems"
        :label="current"
        class="menu-drop-down"
        @select="select(currencyItems[$event]?.currency)"
    />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import {
    type AppCurrency,
    useCurrency,
    useCurrencyPlugin,
} from '@/plugins/currency'
import {
    getIsActiveRegion,
    type RegionFragmentMap,
    useRegionPlugin,
} from '@/plugins/region'

import MenuDropDown, {
    type MenuDropDownItem,
} from '@/components/ui/menus/MenuDropDown.vue'

const { selectCurrency } = useCurrencyPlugin()
const { regions } = useRegionPlugin()

type DropDownItemWithCurrency = MenuDropDownItem & { currency: AppCurrency }
type GroupedCurrencyDropDownItems = {
    [K in AppCurrency]: DropDownItemWithCurrency
}

// TODO translate
const currencyItems = computed((): DropDownItemWithCurrency[] => {
    const regs: RegionFragmentMap = regions.value ?? ({} as RegionFragmentMap)

    const grouped: Partial<GroupedCurrencyDropDownItems> = {}

    for (const reg of Object.values(regs)) {
        if (reg && getIsActiveRegion(reg.code)) {
            grouped[reg.currency] = {
                label: reg.currency,
                currency: reg.currency,
            }
        }
    }

    return Object.values(grouped)
})

const current = useCurrency()

const select = (currency: AppCurrency | undefined) => {
    if (!currency) {
        return
    }

    selectCurrency(currency)
}
</script>

<style lang="scss" scoped>
.menu-drop-down {
    text-transform: uppercase;

    @include min-width(1024) {
        background: $stone-2;
    }

    :deep(.menu-button) {
        @include min-width(1024) {
            color: $slate;
        }
    }

    :deep(.menu) {
        @include min-width(1024) {
            background: $stone-2;
        }

        .item {
            @include min-width(1024) {
                color: $slate;
            }

            &:focus {
                @include min-width(1024) {
                    color: rgba($slate, 0.7);
                }
            }

            @include min-width(1024) {
                @include hover() {
                    color: rgba($slate, 0.7);
                }
            }
        }
    }
}
</style>
